// @spec GHG-STR-016
'use client';

import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { CommutingSurveyDetail } from '@/features/ghg/commuting-surveys/components';
import i18n from '@/lib/i18n';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/_authenticated/ghg/commuting-surveys/$surveyId')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.surveyDetails'),
  }),
  component: CommutingSurveyDetailPage,
});

/**
 * Commuting survey detail page.
 *
 * Displays comprehensive survey details including:
 * - Survey status and statistics
 * - Invitation management
 * - Aggregated results and charts
 * - Action buttons for sending/closing
 */
function CommutingSurveyDetailPage() {
  const { t } = useTranslation('ghg');
  const navigate = useNavigate();
  const { surveyId } = Route.useParams();

  const handleBack = () => {
    void navigate({ to: '/ghg/commuting-surveys' });
  };

  return (
    <div className="p-8">
      <div className="mx-auto max-w-5xl space-y-6">
        {/* Back button */}
        <Button variant="ghost" size="sm" className="-ml-2" onClick={handleBack}>
          <ArrowLeft className="mr-1 h-4 w-4" />
          {t('commutingSurveysPage.back')}
        </Button>

        {/* Survey Detail Component */}
        <CommutingSurveyDetail surveyId={surveyId} />
      </div>
    </div>
  );
}
